import { w as t } from "../../../comlink-BbStm7MK.js";
function i() {
  const r = new Worker(new URL(
    /* @vite-ignore */
    "" + new URL("../../../assets/optimizer.worker-CDplxtiK.js", import.meta.url).href,
    import.meta.url
  ), {
    type: "module"
  }), e = t(r);
  return { worker: r, api: e };
}
export {
  i as createOptimizerWorkerClient
};
